import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";
import { ChartExportDataRequest } from "@/Patient/Models/GrowthCharts/ChartExportDataRequest";

class PatientGrowthChartActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public updatePatientBornPrematureData(patientId: string, isBornPremature: boolean, bornPrematureWeeks: number): void {
        var requestData = {
            PatientContactId: patientId,
            IsBornPremature: isBornPremature,
            BornPrematureWeeks: bornPrematureWeeks
        };

        this.Execute(ServerOperations.Server.Myle_Patient_BornPremature_Update, requestData);
    }

    public exportPatientCharts(chartsExportData: ChartExportDataRequest): void {
        this.Execute(ServerOperations.Server.Myle_Patient_ExportCharts, chartsExportData);
    }

    public sendChartToPortal(
        objectId: string,
        sharedItem: SharedItem,
        includeLinkedItem: boolean
    ): void {
        const requestData = {
            ObjectId: objectId,
            SharedItemType: sharedItem.SharedItemType,
            Subject: sharedItem.Subject,
            PatientContactId: sharedItem.PatientContactId,
            IncludeLinkedItem: includeLinkedItem,
            Messages: sharedItem.Messages,
            SharedItemId: sharedItem.SharedItemId,
            canPatientReplyWithMessage: sharedItem.CanPatientReplyWithMessage
        };

        this.Execute(ServerOperations.Server.Myle_Patient_Portal_SyncSharedItem, requestData);
    }

    public loadGrowthChartSharedItem(patientContactId: string): void {
        this.Execute(ServerOperations.Server.Myle_Patient_GetGrowthChartSharedItem, { PatientContactId: patientContactId });
    }

    public RevokePortalGrowthChart(sharedItemId: string, sharedItemMessages: number[], userId: string): void {
        const requestData = {
            SharedItemId: sharedItemId,
            SharedItemMessageIds: sharedItemMessages,
            UserId: userId,
            IncludeLinkedItem: true,
            SharedItemType: PortalLinkedItemType.GrowthChart
        };

        this.Execute(ServerOperations.Server.Myle_Patient_Portal_RevokeSharedItem, requestData);
    }
}

export { PatientGrowthChartActions };
